import { InviteRequestLimitError } from '@/shared/domain'
import type { HttpPost } from '@/shared/infra/http'
import { readOtpSendLimitSeconds } from '@/shared/infra/http'
import type { RequestNewInvite } from '@/modules/auth/use-cases'

type RequestNewInviteBody = {
  token: string
}

type RequestNewInviteResponse = {
  requested?: boolean
}

export class AnonRequestNewInviteRepository {
  constructor(private readonly http: HttpPost) {}

  execute: RequestNewInvite = async ({ token }) => {
    try {
      await this.http.post<RequestNewInviteBody, RequestNewInviteResponse>({
        url: '/invitations/request-new',
        body: { token },
      })
    } catch (err) {
      const retryAfterSeconds = readOtpSendLimitSeconds(err)
      if (retryAfterSeconds !== null) {
        throw new InviteRequestLimitError(retryAfterSeconds)
      }
      throw err
    }
  }
}
